import { Navigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import LoginPage from "./LoginPage";
import ProDashboard from "./ProDashboard";

export default function ProGate() {
  const { user } = useAuth();
  if (user === null) {
    return <div className="min-h-screen flex items-center justify-center text-[#0D4045] font-semibold">…</div>;
  }
  if (user === false) return <LoginPage />;
  if (user.role === "admin") return <Navigate to="/admin" replace />;
  return <ProDashboard />;
}
